import React from 'react';
import { faTireRugged } from '@fortawesome/pro-solid-svg-icons/faTireRugged';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TireRuggedSolidIcon(props) {
  return <FontAwesomeIcon icon={faTireRugged} {...props} />;
}
